import AppButton from './AppButton';
import './CtaSection.css';

function CtaSection() {
  return (
    <section className="cta-section" id="download">
      <div className="sparkle" aria-hidden="true">
        <span />
      </div>
      <div>
        <h2>Start your weekly ritual</h2>
        <p>Private, simple, and made for the people who matter.</p>
      </div>
      <AppButton />
    </section>
  );
}

export default CtaSection;
